import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import Button from '../../Parts/Button'
import { addCommas } from '../../../utils/utils';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
  },

  container: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 20px',
  },

  row: {
    padding: '22px 0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    borderBottom: '1px solid #D8DBDF',
    boxSizing: 'border-box',
    color: '#181819',
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    margin: '50px 0',
  }
});

class ConfirmExeSearchDialog extends React.Component {
  render() {
    const { classes, toggleDialog, isOpen, companys, confirm } = this.props;
    let { company_name, corporate_number } = companys;
    // 検索内容を表示するための配列を生成する（法人番号がなければ会社名を表示する）
    let searchCorporations = [];
    if (corporate_number) {
      searchCorporations = [...corporate_number];
      corporate_number.forEach((item, i) => {
        if (company_name && !item) {
          searchCorporations[i] = company_name[i];
        }
      });
    } else {
      searchCorporations = [...company_name];
      searchCorporations = searchCorporations.filter(item => !!item);
    }
    // 重複している要素を排除
    const deduplicationCorporations = searchCorporations.filter((item, idx) => searchCorporations.indexOf(item) === idx);
    const duplicateCount = searchCorporations.length - deduplicationCorporations.length;

    const displayItemCount = 5;
    return (
      <DialogModal
        title="法人番号・会社名で一括検索"
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div className={classes.container}>
          <div className={classes.row} style={{ padding: "30px 0" }}><b>以下の内容で検索します</b></div>

          {deduplicationCorporations.slice(0, displayItemCount).map((c, i) => (
            <div className={classes.row} key={i}>{c}</div>
          ))}

          {(deduplicationCorporations.length <= displayItemCount && duplicateCount > 0) && (
            <div className={classes.row} style={{ color: "#71737B", padding: '25px 0 0 0', border: 'none' }}>
              {duplicateCount}件重複で削除
            </div>
          )}

          {deduplicationCorporations.length > displayItemCount && (
            <div className={classes.row} style={{ color: "#71737B", padding: '25px 0 0 0', border: 'none' }}>
              …他{addCommas(deduplicationCorporations.length - displayItemCount)}件の項目
              {duplicateCount > 0 ? ` ${duplicateCount}件重複で削除` : ''}
            </div>
          )}

          <div className={classes.buttonContainer}>
            <Button
              handleClickButton={toggleDialog}
              text="キャンセル"
              type="ghost"
            >
            </Button>
            <Button
              handleClickButton={() => {
                confirm();
                toggleDialog(companys, companys[corporate_number] && companys[corporate_number].length > 0);
              }}
              text="法人番号・会社名で一括検索"
            >
            </Button>
          </div>
        </div>

      </DialogModal>
    );
  }
}

ConfirmExeSearchDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  companys: PropTypes.object.isRequired,
  confirm: PropTypes.func.isRequired,
};

export default withStyles(styles)(ConfirmExeSearchDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ConfirmExeSearchDialog.jsx